import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c37d2ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Profile", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "intro" }, " Change your email preferences below: ", -1))
const _hoisted_4 = {
  key: 0,
  class: "success-msg"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, " Full Name: ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, " Email: ", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, " Country: ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", { class: "email-label" }, " Email subscriptions? ", -1))

import { useMsal } from '@/msal/useMsal';
import { ref, watch } from 'vue';
import api from '@/api/api'
import { useMsalAuthentication } from '@/msal/useMsalAuthentication';
import { loginRequest } from '@/authConfig';
import { InteractionType } from '@azure/msal-browser';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { accounts } = useMsal()
const { result, acquireToken } = useMsalAuthentication(InteractionType.Redirect, loginRequest)
const idTokenClaims: any = accounts.value[0].idTokenClaims
console.log(idTokenClaims)
const subscriptionStatus = ref(true)
const success = ref(false)
const savePref = async () => {
    const user = {
        email: idTokenClaims.emails[0],
        fullName: idTokenClaims.name,
        wantsEmails: subscriptionStatus.value
    }
     await api.post(`SetEmailSubscriptionStatus`, user, {headers: {Authorization: 'Bearer ' + result.value?.accessToken}})
     .catch(() => acquireToken())
     showSuccess()
}

const showSuccess = () => {
    success.value = true
    setTimeout(() => success.value = false, 3000)
}

const getEmailSubscription = async () => {
    const response = await api.get(`GetEmailSubscriptionStatus/${idTokenClaims.emails[0]}`,
    {headers: {Authorization: 'Bearer ' + result.value?.accessToken}}) 
    subscriptionStatus.value = response.data
}


watch((result), async () => {
    await getEmailSubscription()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_Transition, { name: "successPopIn" }, {
      default: _withCtx(() => [
        (success.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Successfully saved email preferences."))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("dl", null, [
      _hoisted_5,
      _createElementVNode("dd", null, _toDisplayString(_unref(idTokenClaims).name), 1),
      _hoisted_6,
      _createElementVNode("dd", null, _toDisplayString(_unref(idTokenClaims).emails[0]), 1),
      _hoisted_7,
      _createElementVNode("dd", null, _toDisplayString(_unref(idTokenClaims).country), 1),
      _hoisted_8,
      _createElementVNode("dd", null, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((subscriptionStatus).value = $event))
        }, null, 512), [
          [_vModelCheckbox, subscriptionStatus.value]
        ])
      ])
    ]),
    _createElementVNode("div", { class: "bottom-nav" }, [
      _createElementVNode("button", { onClick: savePref }, "Save Preferences")
    ])
  ]))
}
}

})